/** Store-settings rules (SELL-08). Pure: no I/O. */

// The Setting.saveBranding field each brand.* row maps to (models/Setting.model.js BRAND_FIELDS).
const BRAND_FIELD = { 'brand.name': 'name', 'brand.tagline': 'tagline', 'brand.primary': 'primary' };

/** The Setting.saveBranding payload for a branding form's changes ({} when nothing changed). Exported for tests. */
export function brandingPayload(changes) {
  return Object.fromEntries((changes || []).map((c) => [BRAND_FIELD[c.key], c.value]));
}

/** Split pasted PIN codes; return { valid, invalid } (6 digits, not starting with 0). Exported for tests. */
export function parsePins(text) {
  const parts = String(text || '').split(/[\s,;]+/).map((s) => s.trim()).filter(Boolean);
  return {
    valid: [...new Set(parts.filter((p) => /^[1-9]\d{5}$/.test(p)))],
    invalid: parts.filter((p) => !/^[1-9]\d{5}$/.test(p)),
  };
}

export const BRAND_KEYS = ['brand.name', 'brand.tagline', 'brand.primary'];

/** Which Setting rows to update or create for a branding form. Exported for tests. */
export function brandingChanges(rows, form) {
  const byKey = Object.fromEntries((rows || []).map((r) => [r.key, r]));
  return BRAND_KEYS.flatMap((key) => {
    const value = form[key] == null ? '' : String(form[key]);
    const row = byKey[key];
    if (row) return (row.value || '') === value ? [] : [{ op: 'update', id: row.id, key, value }];
    return value ? [{ op: 'create', key, value }] : [];
  });
}

/**
 * Settings tab → { done, optional } from the store setup checklist (MERCH-58): an item
 * belongs to the tab its path opens (/settings?tab=<key>). Several items on one tab:
 * done when all are; optional only when all are. Exported for tests.
 */
export function tabCompleteness(items) {
  const out = {};
  for (const i of items || []) {
    const m = /^\/settings\?tab=([\w-]+)/.exec(i.path || '');
    if (!m) continue;
    const prev = out[m[1]];
    out[m[1]] = prev ? { done: prev.done && i.done, optional: prev.optional && i.optional } : { done: Boolean(i.done), optional: Boolean(i.optional) };
  }
  return out;
}

/** Contact channels the customer consented to, with the matching value (if the server returned it). */
export function consentedChannels(lead) {
  const c = lead.consent || {};
  return [
    c.call && lead.phone ? { key: 'call', label: 'Call', value: lead.phone, href: `tel:${lead.phone.replace(/\s/g, '')}` } : null,
    c.whatsapp && lead.phone ? { key: 'whatsapp', label: 'WhatsApp', value: lead.phone, href: `https://wa.me/${lead.phone.replace(/\D/g, '')}` } : null,
    c.email && lead.email ? { key: 'email', label: 'Email', value: lead.email, href: `mailto:${lead.email}` } : null,
  ].filter(Boolean);
}
